

export default class noteRequest {
  constructor(service) {
    this.service = service;
  }

  getNoteList$() {
    return this.service
      .fetch$({
        method: 'GET',
        url: '/note',
      });
  }

  createNote$(message) {
    return this.service
      .fetch$({
        method: 'POST',
        url: '/note',
        body: {
          message,
        },
      });
  }

  updateNote$(id, message) {
    return this.service
      .fetch$({
        method: 'PUT',
        url: `/note/${id}`,
        body: {
          message,
        },
      });
  }

  deleteNote$(id) {
    return this.service
      .fetch$({
        method: 'DELETE',
        url: `/note/${id}`,
      });
  }
}
